module.exports = __webpack_public_path__ + "img/green2.9432d278.svg";